export function buildMemberReportFilterKey(userId: string, routeId: string) {
  return `report-membership-widget-filter-${userId}-${routeId}`;
}
